export enum DeliverySchedulingFormType {
  PickupCoordination = 'PickupCoordination',
  DropoffCoordination = 'DropoffCoordination'
}
